export default {
  backByButton: {action: 'back', actionContent: 'byButton'},
  backByReturnKey: {action: 'back', actionContent: 'byReturnKey'},
  backByPlatformLink: {action: 'back', actionContent: 'byExploreLink'},
  backByLogo: {action: 'back', actionContent: 'byLogo'},
  categoryNavigate: {action: 'navigate', actionContent: 'category'},
  categoryChange: {action: 'search', actionContent: 'byCategory'},
  changeLanguage: {action: 'changeLanguage'},
  nextInstruction: {action: 'nextInstruction', actionContent: 'byButtonAtTheEndOfInstruction'},
  relatedInstruction: {action: 'relatedInstruction', actionContent: 'byButtonAtTheEndOfInstruction'},
  leaveStepsOverview: {action: 'back'},
  nextStepByButton: {action: 'next', actionContent: 'byButton'},
  prevStepByButton: {action: 'previous', actionContent: 'byButton'},
  nextStepBySwipe: {action: 'next', actionContent: 'bySwipe'},
  prevStepBySwipe: {action: 'previous', actionContent: 'bySwipe'},
  closeHintByButton: {action: 'closeHint', actionContent: 'byButton'},
  closeHintByBackground: {action: 'closeHint', actionContent: 'byBackground'},
  openHint: {action: 'openHint'},
  search: {action: 'search'},
  cancelSearch: {action: 'cancel'}
};
